import request from '@/plugins/ecommerce_axios'
import request_admin from '@/plugins/admin_axios'

export const loginApi = async (formLogin, admin_login = true) => {
  const formData = new FormData()
  formData.append('email', formLogin.email)
  formData.append('password', formLogin.password)
  formData.append('admin_login', admin_login)

  const response = await request.post('/user/login/', formData)
  return response.data
}

export const checkAuthApi = async () => {
  const response = await request.get('/user/check-auth/')
  return response.data
}

export const LogoutApi = async () => {
  const response = await request_admin.get('user/logout/')
  return response.data
}
